// extracted by mini-css-extract-plugin
export default {"content":"PdfViewer__content--o0rkB","header":"PdfViewer__header--AjMm1","title":"PdfViewer__title--mPmaU","icon":"PdfViewer__icon--sVpKw","name":"PdfViewer__name--wqjbe"};